import CustomPortal from "../../CustomPortal";
import VerifyCode from '../../reset-password-component/VerifyCode';

const VerifyCodeForm = () => {
    return (
        <CustomPortal
            header="Reset password"
            Component={VerifyCode}
        />
    );
}

export default VerifyCodeForm;